import { render, staticRenderFns } from "./ActivityChartReview.vue?vue&type=template&id=2e5f8c24&"
import script from "./ActivityChartReview.vue?vue&type=script&lang=js&"
export * from "./ActivityChartReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports